import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconChair: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"chair, seat"} maskId="square-filled-radius-0-stroke-1-IconChair"><path fillRule="evenodd" clipRule="evenodd" d="M5 11V2H19V11H16V13H20V14H18.75V22H17.75V18H6.25V22H5.25V14H4V13H8V11H5ZM9 11V13H15V11H9ZM17.75 14V17H6.25V14H17.75Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconChair;
